(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-blog-section"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  //fetch('https://blog.verdianaramina.com/wordpress/wp-json/wp/v2/posts?_embed&per_page=4')
  fetch('https://blog.verdianaramina.com/wordpress/wp-json/wp/v2/posts?_embed&per_page=4')
    .then(response => response.json())
    .then(data => {
      const articlesContainer = document.getElementById('articles');
      data.forEach(article => {
        const articleDiv = document.createElement('div');
        articleDiv.className = 'article-card';
        const title = article.title.rendered;
        const excerpt = article.excerpt.rendered;
        const imageUrl = article._embedded['wp:featuredmedia'][0].source_url;
        const articleLink = article.link; // Aggiungi il link dell'articolo

        articleDiv.innerHTML = `
          <div class="article-image" style="background-image: url('${imageUrl}');"></div>
          <div class="article-text">
            <h3>${title}</h3>
            <p>${excerpt}</p>
          </div>
        `;
        
        // Aggiunta dell'evento click per l'intera card
        articleDiv.addEventListener('click', function() {
          console.log(articleLink.replace('/wordpress/','/'))
          window.location.href = articleLink.replace('/wordpress/','/');
        });

        articlesContainer.appendChild(articleDiv);
      });
    })
    .catch(error => console.error('Error fetching articles:', error));
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-professionist"] && !Shopify.designMode) return;
  try {
    
  window.globalUsers = [];
  
  async function fetchUserData() {
    const url = 'https://api.verdianaramina.com/V1.0/users/1';
    try {
        const response = await fetch(url);
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Errore durante il recupero dei dati:', error);
    }
}

window.searchUser = async () => {
  
    const input = document.getElementById('searchBar').value.toLowerCase();
    const filteredUsers = window.globalUsers.filter(user => user.username.toLowerCase().includes(input));

    const container = document.getElementById('user-card-container');
    container.innerHTML = ''; // Pulisce il contenitore prima di riempirlo nuovamente

    await renderCards(filteredUsers, container);
}


async function renderCards(users, container) {
  users.forEach(user => {
      let socialLinks = '';
      if (user.social) {
          if (user.social.instagram) {
              socialLinks += `<a href="${user.social.instagram}"><i class="fa-brands fa-instagram"></i></a>`;
          }
          if (user.social.facebook) {
              socialLinks += `<a href="${user.social.facebook}"><i class="fa-brands fa-facebook"></i></a>`;
          }
          if (user.social.whatsapp) {
              socialLinks += `<a href="https://wa.me/${user.social.whatsapp}"><i class="fa-brands fa-whatsapp"></i></a>`;
          }
          if (user.social.email) {
              socialLinks += `<a href="mailto:${user.social.email}"><i class="fa-solid fa-envelope"></i></a>`;
          }
          if (user.social.website) {
              socialLinks += `<a href="${user.social.website}"><i class="fa-solid fa-globe"></i></a>`;
          }
          if (user.social.twitter) {
              socialLinks += `<a href="https://twitter.com/${user.social.twitter}"><i class="fa-brands fa-twitter"></i></a>`;
          }
          if (user.social.maps) {
              socialLinks += `<a href="${user.social.maps}"><i class="fa-solid fa-map-marker-alt"></i></a>`;
          }     
          if (user.social.telegram) {
              socialLinks += `<a href="https://t.me/${user.social.telegram}"><i class="fa-brands fa-telegram"></i></a>`;
          }
      }
  
      const cardHtml = `
          <div class="user-card">
            <div class="user-content">
              <img class="user-cover-image" src="${user.cover_image}" alt="Cover Image">
              <img class="user-profile-image" src="${user.image}" alt="Profile Image">
              <h3 class="nome-professionista">${user.username}</h3>
              <div class="social-icons">${socialLinks}</div>
              <p>${user.description}</p>
            </div>
          </div>
      `;
      container.innerHTML += cardHtml;
  });
}

async function getProfessionists() {
    const preloader = document.getElementById('preloader');
    preloader.style.display = 'block'; // Mostra preloader

    const users = await fetchUserData();
    window.globalUsers = users;
    const container = document.getElementById('user-card-container');
    container.innerHTML = ''; // Pulisce eventuali contenuti precedenti

    await renderCards(users, container);

    preloader.style.display = 'none';
}


document.addEventListener("DOMContentLoaded", function(){
    getProfessionists();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer-custom-menu"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {

  // Seleziona il menu personalizzato
  const customMenu = document.querySelector('.footer-custom-menu');
  const toggleButton = document.querySelector('.menu-toggle-button');
  toggleButton.addEventListener('click', function() {
    toggleButton.classList.add('display-none');
    customMenu.classList.toggle('closed');
  });

  const closeMenu = document.querySelector('.close-footer-menu');
  console.log(closeMenu)
  closeMenu.addEventListener('click', function() {
    customMenu.classList.add('closed');
    toggleButton.classList.toggle('display-none');
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
